var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-dialog', {
    attrs: {
      "max-width": "1200px",
      "transition": "dialog-bottom-transition",
      "persistent": ""
    },
    model: {
      value: _vm.dialog,
      callback: function callback($$v) {
        _vm.dialog = $$v;
      },
      expression: "dialog"
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("mdi-open-in-new")]), _vm._v(" " + _vm._s(_vm.$t("components.PartnerReportDetail.repair.ReportClearanceApprovalRequestDialog.title", {
    title: _vm.report.title
  })) + " "), _c('v-spacer'), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function click() {
        return _vm.close();
      }
    }
  }, [_c('v-icon', [_vm._v("mdi-close")])], 1)], 1), _c('v-card-text', [_c('preselect-template-card', {
    ref: "templateCard",
    staticClass: "mt-1",
    attrs: {
      "templateKey": _vm.PreselectTemplateKeysEnum.REQUEST_CLEARANCE_APPROVAL_MAIL,
      "language": _vm.partner.language,
      "partnerId": _vm.partner.id,
      "from": [_vm.partner],
      "context": _vm.context,
      "to": _vm.clearanceApproval.seller ? [_vm.clearanceApproval.seller.email] : [],
      "refs": [{
        refId: _vm.clearanceApproval.id,
        refType: _vm.ResourceEnum.CLEARANCE_APPROVAL
      }, {
        refId: _vm.report.id,
        refType: _vm.ResourceEnum.REPORT
      }],
      "isTicketEnabled": true
    }
  })], 1), _c('v-card-actions', {
    staticClass: "mt-6 pa-4"
  }, [_c('v-spacer'), _c('v-btn', {
    attrs: {
      "elevation": "0",
      "color": "primary",
      "disabled": !_vm.validForm
    },
    on: {
      "click": function click() {
        return _vm.sendMail();
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("submit")) + " ")])], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }